/**
 * Activate a homepage theme mode.
 * Live: navigates straight to the For Brands / Direct page (no local proxy).
 */
(function () {
  var FALLBACK = '/pages/dm-for-brands';

  function goDirect(link) {
    window.location.href = (link && link.getAttribute('href')) || FALLBACK;
  }

  function activateAndGo(mode, link) {
    goDirect(link);
    return Promise.resolve();
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-dm-open-theme]');
    if (!link) return;

    var mode = link.getAttribute('data-dm-open-theme');
    if (!mode) return;

    event.preventDefault();
    link.setAttribute('aria-busy', 'true');

    activateAndGo(mode, link).catch(function () {
      goDirect(link);
    });
  });
})();
